module.exports = __webpack_public_path__ + "334fa541ffc0691fe4b723850b3a4c38.png";